import { useEffect, useState } from 'react'

import { getChatroom, readChatroom } from '../../../../api'
import { useApi, useAsyncCallback, useNotification } from '../../../../hooks'
import { getChatroomFromResponse } from '../../Chatroom.utils'

export function useChatroomInit({ chatroomData, outboundUuid, uuid }) {
  const [chatroom, setChatroom] = useState(null)

  const chatroomApi = useApi()

  const { handleAddErrorNotification } = useNotification()

  useEffect(() => {
    if (uuid && !chatroomData) {
      chatroomApi
        .call(getChatroom, { outboundUuid, uuid })
        .then(response => {
          if (response) {
            setChatroom(getChatroomFromResponse(response))
          }
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })

      return () => {
        chatroomApi.abort()
      }
    }
  }, [outboundUuid, uuid])

  const handleMarkAsRead = useAsyncCallback(
    () => readChatroom({ outboundUuid, uuid }),
    [outboundUuid, uuid]
  )

  return {
    chatroom: chatroomData ? chatroomData.chatroom : chatroom,
    handleMarkAsRead,
  }
}
